import { render, staticRenderFns } from "./gauge-chart.vue?vue&type=template&id=15c4edb6&scoped=true&"
import script from "./gauge-chart.component.ts?vue&type=script&lang=ts&"
export * from "./gauge-chart.component.ts?vue&type=script&lang=ts&"
import style0 from "./gauge-chart.scss?vue&type=style&index=0&id=15c4edb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4edb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c4edb6')) {
      api.createRecord('15c4edb6', component.options)
    } else {
      api.reload('15c4edb6', component.options)
    }
    module.hot.accept("./gauge-chart.vue?vue&type=template&id=15c4edb6&scoped=true&", function () {
      api.rerender('15c4edb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gauge-chart/gauge-chart.vue"
export default component.exports